module.exports = __webpack_public_path__ + "img/TZS09676_composito.b27b6c0b.jpeg";